import * as React from "react";
import { SVGProps } from "react";

const UserOutline: React.FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width={props.width || 48}
    height={props.height || 48}
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M24 25C17.9361 25 13 20.0639 13 14C13 7.93614 17.9361 3 24 3C30.0639 3 35 7.93614 35 14C35 20.0639 30.0639 25 24 25ZM24 5C19.0439 5 15 9.04386 15 14C15 18.9561 19.0439 23 24 23C28.9561 23 33 18.9561 33 14C33 9.04386 28.9561 5 24 5Z"
      fill="#DA291C"
      stroke="#DA291C"
    />
    <path
      d="M41.1803 45C40.6364 45 40.1803 44.5439 40.1803 44C40.1803 36.7238 32.8044 31 24.0003 31C15.1962 31 7.82031 36.7238 7.82031 44C7.82031 44.5439 7.36417 45 6.82031 45C6.27645 45 5.82031 44.5439 5.82031 44C5.82031 35.8193 13.8852 29 24.0003 29C34.1154 29 42.1803 35.8193 42.1803 44C42.1803 44.5439 41.7242 45 41.1803 45Z"
      fill="#DA291C"
      stroke="#DA291C"
    />
  </svg>
);

export default UserOutline;
